export default __webpack_public_path__ + "static/media/vidsocialimpact1.07426abf.mp4";